import React from 'react';
import { IconProps } from '.';

const SvgThumbsDown = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M11.836 22h.428c.704 0 1.707-.114 2.48-.724.844-.667 1.224-1.766.96-3.303l-.012-.066L14.57 14.8h4.574c1.418 0 2.607-1.12 2.607-2.55v-.058L20.25 2.5h-18V15h5.441l4.145 7ZM8.75 13.845l3.93 6.636c.446-.043.852-.16 1.134-.382.29-.229.6-.692.422-1.809L12.43 13.3h6.712c.615 0 1.079-.463 1.106-1L18.964 4H8.75v9.845ZM7.25 4v9.5h-3.5V4h3.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgThumbsDown;
